module.exports = __webpack_public_path__ + "img/example.749a925a.png";